import { HomeIcon, SimulateIcon, IntelIcon, AnalystIcon, CurveIcon, ReviewIcon } from './icons';

/**
 * The shell nav — shared by SideNav, BottomTabs, and the command palette.
 * featureKey matches the draft-registry keys in ShellContext.
 * Paths are the EXISTING routes; features migrate into the shell per
 * .claude/SHELL-REDESIGN-PLAN.md without changing URLs.
 *
 * NOTE: The Taco Stand (/taco-stand) is deliberately NOT listed — it's live at
 * its URL but unlinked (dark launch, direct-URL only). Don't re-add without asking.
 * NOTE: The Market (/market) is also deliberately NOT listed — same dark launch,
 * direct-URL only (no sidebar item, no bottom tab, no palette entry). Its icon
 * (StocksIcon) is ready in icons.js for when it goes public.
 * NOTE: Trade Builder (/trade-packages), Rate My Trade (/rate-my-trade), and
 * Marketplaces (/marketplaces) are deliberately NOT listed — sunset from nav in
 * favor of Analyst Reviews below. All stay live at their URLs (shared links,
 * in-progress packages/listings still work).
 */
export const NAV_ITEMS = [
  { key: 'home', label: 'Home', shortLabel: 'Home', path: '/home', icon: HomeIcon, featureKey: 'home' },
  { key: 'curve', label: 'The Curve', shortLabel: 'Curve', path: '/curve', icon: CurveIcon, featureKey: 'curve' },
  { key: 'intel', label: 'Manager Intel', shortLabel: 'Intel', path: '/intel', icon: IntelIcon, featureKey: 'intel', altPaths: ['/manager-intel'] },
  { key: 'simulate', label: 'Simulate', shortLabel: 'Simulate', path: '/simulate', icon: SimulateIcon, featureKey: 'simulate' },
  { key: 'analyst-reviews', label: 'Analyst Reviews', shortLabel: 'Reviews', path: '/analyst/fantasynerdboi', icon: ReviewIcon, featureKey: 'analyst-reviews' },
  { key: 'analyst-dash', label: 'Analyst Studio', shortLabel: 'Studio', path: '/analyst/dashboard', icon: AnalystIcon, featureKey: 'analyst-dashboard', requiresRole: 'analyst', altPaths: ['/analyst/reviews'] },
];

export const isNavItemActive = (item, pathname) => {
  const paths = [item.path, ...(item.altPaths || [])];
  return paths.some((p) => pathname === p || pathname.startsWith(`${p}/`));
};
